import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Spedizione Itaobuy in Italia: Costi, Tempi e Consigli 2026',
  url: `${siteUrl}/itaobuy-spedizione-italia`,
  description: 'Guida completa alla spedizione itaobuy in Italia: quanto costa, quanto tempo impiega e come risparmiare sulle spese di consegna.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function SpedizionePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ SPEDIZIONE</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Spedizione Itaobuy in Italia: Costi, Tempi e Consigli 2026
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Guida completa alla <strong className="text-background-50">spedizione itaobuy in Italia</strong>: quanto costa, quanto tempo impiega e come risparmiare sulle spese di consegna.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per tutte le informazioni.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Costi di Spedizione verso l'Italia</h2>
              <p className="mb-4">I <strong className="text-foreground-950">costi di spedizione itaobuy verso l'Italia</strong> variano in base al peso del pacco, al metodo di spedizione scelto e alla destinazione specifica. In media, una spedizione standard può costare tra i 15 e i 40 euro, mentre le opzioni express possono superare i 60 euro. Il consiglio è di valutare attentamente il rapporto costo-beneficio in base all'urgenza.</p>
              <p>Utilizzando <strong className="text-foreground-950">itaobuy spreadsheet</strong>, puoi trovare prodotti con costi di spedizione già inclusi o indicati chiaramente, evitando sorprese al momento del checkout. Consulta anche la <Link to="/itaobuy-prezzi" className="text-primary-600 font-medium hover:underline">guida ai prezzi</Link>.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Tempi di Consegna Stimati</h2>
              <p className="mb-4">I <strong className="text-foreground-950">tempi di consegna itaobuy per l'Italia</strong> variano generalmente tra 7 e 21 giorni lavorativi per la spedizione standard, mentre le opzioni express possono ridurre l'attesa a 5-10 giorni. Fattori come la dogana e i periodi di alta stagione (Natale, Black Friday) possono influenzare i tempi.</p>
              <p>Per una panoramica completa, leggi anche la <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-primary-600 font-medium hover:underline">guida completa</Link>.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Come Risparmiare sulla Spedizione</h2>
              <p className="mb-4">Per <strong className="text-foreground-950">risparmiare sulla spedizione itaobuy</strong>, il consiglio migliore è di raggruppare più acquisti in un unico ordine. Molti utenti italiani utilizzano questa strategia per ammortizzare i costi di consegna. Inoltre, alcune categorie prodotto offrono spedizione gratuita sopra una certa soglia di spesa.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Pronto per Ordinare?</h3>
              <p className="text-sm text-foreground-600 mb-5">Accedi al database e calcola i costi di spedizione per i tuoi prodotti.</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Spedizione itaobuy Italia</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}